<!--<template>
  <div class="bg-brand fixed-bottom b-container fluid footer"></div>
</template>-->
<template>
  <div class="bg-brand fixed-bottom">
    <b-navbar toggleable="lg" type="dark" b-row class="nav">
      <b-navbar-nav>
        <b-col>
          <router-link to="/Home"><i class="fas fa-home"></i>Home</router-link>
        </b-col>
        <b-col>
          <router-link to="/Pedidos"><i class="fas fa-list-ul"></i>Pedidos</router-link>
        </b-col>
        <b-col>
          <router-link to="/Clientes"><i class="fas fa-users"></i>Clientes</router-link>
        </b-col>
        <b-col>
          <router-link to="/Relatorios"><i class="fas fa-chart-bar"></i>Relatórios</router-link>
        </b-col>
        <b-col>
          <router-link to="/Catalogo"><i class="fas fa-book-open"></i>Catálogo</router-link>
        </b-col>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script>
  export default {
    name: 'FooterVue'
  }
</script>
<style scoped>
  i {
    font-size: 18px;
    display: block;
  }
  a {
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/FooterVue.vue